import React, { forwardRef } from 'react';

// Define the types for the component props
interface EditIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const EditIcon = forwardRef<SVGSVGElement, EditIconProps>(
  ({ width = 20, height = 20, color = '#424242' }, ref) => {
    return (
      <svg ref={ref} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.8899 3.09969L4.14811 10.2356C3.89355 10.5066 3.6472 11.0403 3.59793 11.4099L3.2941 14.0704C3.18735 15.0312 3.87712 15.6881 4.82967 15.5239L7.47382 15.0722C7.84334 15.0065 8.36067 14.7356 8.61523 14.4564L15.357 7.32047C16.523 6.08872 17.0486 4.68453 15.2338 2.9683C13.4272 1.2685 12.0559 1.86795 10.8899 3.09969Z" stroke="#424242" strokeWidth="1.34372" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.76367 4.29297C10.1168 6.55938 11.9562 8.29203 14.239 8.52196" stroke={color} strokeWidth="1.34372" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.46289 18.2109H17.2438" stroke={color} strokeWidth="1.34372" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

    );
  }
);

EditIcon.displayName = 'EditIcon';

export default EditIcon;
